import { I18n } from '@calendly/i18n'
import { BatchAction } from '@calendly/table'
import { useDispatch, useSelector } from 'react-redux'

import { openApplyManagedEventsPopup } from 'features/managed_event_types'
import { isUserGroupsEnabledSelector } from 'features/user_groups'
import { scimGroupMappingStateSelector } from 'selectors/current_organization'

import { selectedIdsSelector } from './selectors'
import {
  openBatchChangeRolePopup,
  openBatchRemoveUserPopup,
  openAddToGroupPopup
} from './slice'

export const ActiveBatchControls = () => {
  const dispatch = useDispatch()

  const isUserGroupsEnabled = useSelector(isUserGroupsEnabledSelector)
  const scimGroupMappingState = useSelector(scimGroupMappingStateSelector)
  const canAddMembersToGroup = isUserGroupsEnabled && scimGroupMappingState !== 'activated'

  const selectedMembershipIds = useSelector(selectedIdsSelector)

  return (
    <>
      <BatchAction onClick={() => dispatch(openBatchChangeRolePopup())}>
        {I18n.t('publisher.organization.members.change_role')}
      </BatchAction>
      {canAddMembersToGroup && (
        <BatchAction onClick={() => dispatch(openAddToGroupPopup())}>
          {I18n.t('publisher.organization.members.add_to_group.add')}
        </BatchAction>
      )}
      <BatchAction onClick={() => dispatch(openBatchRemoveUserPopup())}>
        {I18n.t('publisher.organization.members.batch_remove.remove')}
      </BatchAction>
      <BatchAction onClick={() => dispatch(openApplyManagedEventsPopup(selectedMembershipIds))}>
        {I18n.t('publisher.organization.members.bulk_managed_events_applying.apply')}
      </BatchAction>
    </>
  )
}
